"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const classnames_1 = __importDefault(require("classnames"));
const lodash_1 = require("lodash");
const react_tiny_virtual_list_dmk_1 = __importDefault(require("react-tiny-virtual-list-dmk"));
const react_device_detect_1 = require("react-device-detect");
const react_use_1 = require("react-use");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const mui_1 = require("tss-react/mui");
const datasets_1 = require("companion-app-components/flux/datasets");
const auth_1 = require("companion-app-components/flux/auth");
const accounts_1 = require("companion-app-components/flux/accounts");
const core_1 = require("companion-app-components/utils/core");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const selectors_1 = require("data/transactionList/selectors");
const transactionSelectors = __importStar(require("data/transactions/selectors"));
const utils_1 = require("data/transactions/utils");
const icon_arrow_right_inline_svg_1 = __importDefault(require("assets/icon-arrow-right.inline.svg"));
const accounts_svg_1 = __importDefault(require("assets/nav-menu/accounts.svg"));
const RegisterHeader_1 = __importDefault(require("components/TransactionRegister/RegisterHeader"));
const BulkEditPanel_1 = __importDefault(require("components/BulkEditPanel"));
const DocumentBrowser_1 = __importDefault(require("components/DocumentBrowser"));
const store_1 = __importDefault(require("store"));
const styles_1 = require("./styles");
const TransactionRow2_1 = __importDefault(require("../TransactionRow2"));
const TxnPageFooter_1 = __importDefault(require("./TxnPageFooter"));
const log = (0, core_1.getLogger)('components/TransactionPage/index.js');
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const REDISPLAY_DELAY = 5;
const TransactionPage = (props) => {
    const { classes, theme } = useStyles();
    const accounts = (0, react_redux_1.useSelector)(accounts_1.accountsSelectors.getAccountsById);
    const transactionListMetrics = (0, react_redux_1.useSelector)((state) => (0, selectors_1.transactionListMetrics)(state, props.acctTxns));
    const loadPending = (0, react_redux_1.useSelector)(transactionSelectors.getLoadPending);
    const featureFlags = (0, react_redux_1.useSelector)(feature_flags_1.featureFlagsSelectors.getFeatureFlags);
    const hideLoanTransactions = featureFlags.get('hideLoanTransactions');
    const datasetId = (0, react_redux_1.useSelector)(auth_1.authSelectors.getDatasetId);
    const datasetsById = (0, react_redux_1.useSelector)(datasets_1.datasetsSelectors.getDatasetsById);
    const [, forceUpdate] = (0, react_1.useReducer)((val) => val + 1, 0);
    const [state, setState] = (0, react_1.useState)({
        displayNodes: [],
        displayHeights: {},
        scrollIndex: null,
        bodyOffset: 0,
        parent: null,
    });
    let numUpdates = 0;
    let recalcWindow = Date.now();
    let footerElHeight;
    let headerElHeight;
    const headerEl = (0, react_1.useRef)(null);
    const footerEl = (0, react_1.useRef)(null);
    const virtualList = (0, react_1.useRef)(null);
    const scrollIndexRef = (0, react_1.useRef)(null);
    const zeroStateMessage = props.zeroStateMessage || "You don't have any transactions in this account yet";
    const makeId = (row, acct) => `txRow:${props.accountIds.hashCode()}${row}:${acct}`;
    const getItemSize = (index) => {
        const node = state.displayNodes[index];
        if (node && node.node) {
            const el = document.getElementById(node.node.props.id);
            if (el) {
                return el.offsetHeight;
            }
            const { id } = node.node.props;
            return state.displayHeights[id] ? state.displayHeights[id] : node.height;
        }
        return 0;
    };
    const rowInnerRef = (elem) => {
        if (elem && elem.id) {
            state.displayHeights[elem.id] = elem.offsetHeight;
            if (elem.className.indexOf('appear') < 0) {
                // eslint-disable-next-line no-param-reassign
                elem.className = `${elem.className} appear`;
            }
        }
    };
    const regComponentRef = (ref, elem) => {
        // eslint-disable-next-line no-param-reassign
        ref.current = elem;
        if (footerEl.current && headerEl.current) {
            footerElHeight = footerEl.current.offsetHeight;
            headerElHeight = headerEl.current.offsetHeight;
            state.bodyOffset = footerElHeight + headerElHeight;
            if (!state.parent) {
                forceUpdate();
            }
            state.parent = state.parent || document.getElementById(props.wrapperId);
        }
    };
    const recalcHeights = (newState) => {
        let needUpdate = false;
        let lastNodeRect = null;
        let nodeMap = state.displayNodes.map((dnode) => {
            if (dnode.node && dnode.node.props) {
                return document.getElementById(dnode.node.props.id); // this.state.domNodes[dnode.node.props.id]);
            }
            return null;
        });
        nodeMap = nodeMap.filter((node) => node && node.offsetHeight !== 0);
        nodeMap.sort((node1, node2) => {
            if (node1 && node2) {
                const rectA = node1.getBoundingClientRect();
                const rectB = node2.getBoundingClientRect();
                return (rectA.top - rectB.top);
            }
            return 0;
        });
        nodeMap.forEach((node, index) => {
            if (node) {
                const actualHeight = node.offsetHeight;
                const compareHeight = state.displayHeights[node.id];
                const nodeRect = node.getBoundingClientRect();
                const nodeHeight = nodeRect.height.toFixed(0);
                const heightFromLastNode = lastNodeRect ? (nodeRect.bottom - lastNodeRect.bottom).toFixed(0) : nodeHeight;
                if (nodeHeight !== heightFromLastNode) {
                    log.log('Height MISMATCH ', index, nodeHeight, heightFromLastNode, compareHeight);
                }
                if ((actualHeight && compareHeight && (actualHeight !== compareHeight)) || (nodeHeight !== heightFromLastNode)) {
                    // if ((actualHeight && compareHeight && (actualHeight !== compareHeight))) {
                    needUpdate = true;
                    // We purposefully do not use setState to ensure we don't trigger uneeded updates
                    state.displayHeights[node.id] = actualHeight;
                }
                lastNodeRect = nodeRect;
            }
            return true;
        });
        if (virtualList.current) {
            virtualList.current.recomputeSizes(0);
        }
        // establish recalc windows of 1 seconds in length
        if (Date.now().valueOf() - recalcWindow.valueOf() > 1000) {
            recalcWindow = Date.now();
            numUpdates = 0;
        }
        // only re-update up to 5 times per recalc window
        if (needUpdate && numUpdates < 5) {
            setState((prevState) => (Object.assign(Object.assign(Object.assign({}, prevState), newState), { scrollIndex: scrollIndexRef.current })));
            numUpdates += 1;
            return false;
        }
        return true;
    };
    const updateSize = () => {
        numUpdates = 0;
        let resizeTimer;
        if (resizeTimer) {
            clearTimeout(resizeTimer);
        }
        resizeTimer = setTimeout(() => forceUpdate(), 100);
    };
    const onSizeChange = () => {
        numUpdates = 0;
        setTimeout(recalcHeights, 250);
    };
    const onScroll = () => {
        if (!props.wrapText || !props.longCats) {
            return;
        }
        setTimeout(() => (0, lodash_1.throttle)(recalcHeights, 500), REDISPLAY_DELAY);
    };
    //-------------------------------------------------------
    // Render Transaction Edit Row
    //
    const renderTransactionEditRow = (callbacks, txn, editable, id, refFn, scriptId, addQcardID = false, _shade = false, lastRow = false, showBalance = true) => {
        const { regEditableFields, flashTx } = props.uiState;
        const doFlash = flashTx && (flashTx === txn.clientId || flashTx === txn.id);
        // do not show transactions for loan accounts
        if (!hideLoanTransactions
            || !accounts_1.accountsUtils.isLoanAccount(accounts_1.accountsSelectors.getAccountById(store_1.default.getState(), txn.accountId))) {
            return (<TransactionRow2_1.default key={`txnPage:${txn.id}`} qcardId={addQcardID ? 'qCard-transaction-first-row' : undefined} accountIds={props.accountIds} refFn={refFn} sizesChanged={onSizeChange} id={id} callbacks={callbacks} txn={txn} editable={Boolean(editable)} lastRow={Boolean(lastRow)} onRowSelect={callbacks.onRowSelect} showAttachmentColumn={Boolean(props.showAttachmentColumn && props.uiState.showAttachmentColumnInHeader)} sortOrder={props.sortOrder} sortBy={props.sortBy} currEditFieldName={editable ? props.currEditFieldName : null} accounts={accounts} regEditableFields={regEditableFields} simpleEdit={editable ? props.uiState.simpleEdit && !props.splitsInDialog : false} selectedTxns={props.uiState.selectedTxns} showBalance={Boolean(showBalance)} doubleAmounts={props.doubleAmounts} deleteDownloaded={props.deleteDownloaded} editDownloaded={props.editDownloaded} showSplitWindow={editable ? Boolean(props.uiState.showSplitWindow && !props.splitsInDialog) : false} showSplitColumn={props.showSplitColumn} showSelectColumn={props.showSelectColumn} showReviewedColumn={props.showReviewedColumn} showAccountColors={props.showAccountColors} longCats={props.longCats} flashTx={Boolean(doFlash)} onFocusField={callbacks.onFocusField} showCurrencySymbol={props.showCurrencySymbol} showAccounts={props.accountIds.size !== 1} registerComfort={props.registerComfort} headerFields={props.headerFields} wrapText={props.wrapText} scriptId={`${props.wrapperId}-${String(scriptId)}`} wrapperId={props.wrapperId} calendar={props.calendar} allAccountIds={props.allAccountIds} isTxnDirty={props.uiState.txnDirty}/>);
        }
        return null;
    };
    //-------------------------------------------------------
    // Render all transactions
    //
    // This function populates this.state.displayNodes
    // and this.state.displayHeights.  displayNodes are an array of
    // REACT node types for rendering, displayHeights is an array of objects
    // containing the actual DOM references as well as their offsetHeight's
    //
    // These arrays can be used to manage virtual scrolling
    //
    const renderTxList = (callbacks, accountIds, acctTxns, showBalance) => {
        const { uiState } = props;
        let editable = false;
        state.displayNodes = [];
        let acctKey = 'acctKey';
        acctKey = accountIds.forEach((v) => `${acctKey}:${v}`);
        acctTxns.keySeq().forEach((key, indexMonth) => {
            var _a, _b;
            let shade = false;
            const keyPrefix = `TxSep:${acctKey}`;
            const shortKey = key.slice(key.indexOf(':') + 1);
            const sectionOpen = uiState.openSections.has(shortKey);
            //----------------------------------
            // push the section header
            //----------------------------------
            let count = state.displayNodes.length;
            let node = (<div id={`${makeId(shortKey, acctKey)}:${sectionOpen ? 'OPEN' : 'CLOSED'}`} ref={(elemDiv) => rowInnerRef(elemDiv)} key={`${keyPrefix}${shortKey}`}>
          <MenuItem_1.default disableGutters className={classes.txnListMenuItem}>
            <Paper_1.default elevation={0} className={(0, classnames_1.default)(classes.txSepSummary)} onClick={() => callbacks.openCloseSection(shortKey)}>
              <IconButton_1.default className={classes.txSepIcon} size="large">
                <icon_arrow_right_inline_svg_1.default width={15} height={15} fill={(_a = theme.components) === null || _a === void 0 ? void 0 : _a.payeeField.displayTemplate} className={sectionOpen ? classes.turnDown90 : classes.turnUp}/>
              </IconButton_1.default>
              <Typography_1.default variant="subtitle1" className={classes.txSepHeading}>
                {shortKey}
              </Typography_1.default>
            </Paper_1.default>
          </MenuItem_1.default>
        </div>);
            if (!props.hideDividers && acctTxns.get(key).size) {
                state.displayNodes.push({ node, height: Number((_b = theme.components) === null || _b === void 0 ? void 0 : _b.register.sectionHeaderHeight) + 1 });
            }
            if (sectionOpen || props.hideDividers) {
                const acctTxnsSet = new Set(acctTxns.get(key));
                acctTxnsSet.forEach((txn, indexTxn) => {
                    //----------------------------------
                    // push the transactions in this section
                    //----------------------------------
                    editable = (uiState.txnBeingEdited && uiState.txnBeingEdited.id === txn.id);
                    const txnToRender = editable ? uiState.txnBeingEdited : txn;
                    count = state.displayNodes.length;
                    node = renderTransactionEditRow(callbacks, txnToRender, editable, makeId(txnToRender.id, acctKey), rowInnerRef, count, (indexMonth === 0 && indexTxn === 0), // Show qCardId on the first txn only
                    shade, false, showBalance);
                    state.displayNodes.push({ node, height: styles_1.MIN_TX_HEIGHT[props.registerComfort] });
                    if (props.scrollToId && (String(props.scrollToId) === String(txn.id))) {
                        scrollIndexRef.current = state.displayNodes.length - 1;
                    }
                    shade = !shade;
                });
            }
        });
        // render virtual row
        let virtualRow;
        if (uiState.showNewTxn) {
            if (uiState.txnBeingEdited && !(0, utils_1.isExistingTxn)(uiState.txnBeingEdited)) {
                virtualRow = renderTransactionEditRow(callbacks, uiState.txnBeingEdited, true, makeId(uiState.txnBeingEdited.clientId || 'lastrow', acctKey), rowInnerRef, 'new', false, true, true, showBalance);
            }
            if (props.sortOrder === 'ascending') {
                state.displayNodes.push({ node: virtualRow, height: styles_1.MIN_TX_HEIGHT[props.registerComfort] });
                if (String(props.scrollToId) === String(uiState.txnBeingEdited && uiState.txnBeingEdited.id)) {
                    scrollIndexRef.current = state.displayNodes.length - 1;
                }
            }
            else {
                state.displayNodes.unshift({ node: virtualRow, height: styles_1.MIN_TX_HEIGHT[props.registerComfort] });
                if (String(props.scrollToId) === String(uiState.txnBeingEdited && uiState.txnBeingEdited.id)) {
                    scrollIndexRef.current = 0;
                }
            }
        }
    };
    const hideEdit = () => props.callbacks.hideModal('bulkEdit');
    const zeroStateContainer = (
    // zeroStateStyle injected prop @ ProjectedBalancesCalendar
    <div className={classes.zeroStateContainer}>
      {!props.zeroStateStyle &&
            <img alt="No Transactions" src={accounts_svg_1.default} className={classes.imgZeroState}/>}
      <br />
      <div className={classes.zeroStateTextBody} style={props.zeroStateStyle && Object.assign({}, props.zeroStateStyle)}>
        {loadPending ? 'Transactions Loading...' : zeroStateMessage
            || "You don't have any transactions in this account yet"}
      </div>
    </div>);
    (0, react_1.useEffect)(() => {
        window.addEventListener('resize', updateSize);
        setTimeout(() => {
            var _a, _b;
            (_b = (_a = document
                .getElementById('txn-register-virtual-list')) === null || _a === void 0 ? void 0 : _a.addEventListener) === null || _b === void 0 ? void 0 : _b.call(_a, 'scroll', onScroll);
        }, 7000);
        setTimeout(recalcHeights, 1000);
        return () => {
            var _a, _b;
            window.removeEventListener('resize', updateSize);
            (_b = (_a = document
                .getElementById('txn-register-virtual-list')) === null || _a === void 0 ? void 0 : _a.removeEventListener) === null || _b === void 0 ? void 0 : _b.call(_a, 'scroll', onScroll);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const adaptPrev = (0, react_use_1.usePrevious)(props.adapt);
    const uiStatePrev = (0, react_use_1.usePrevious)(props.uiState);
    (0, react_1.useEffect)(() => {
        if (adaptPrev !== props.adapt) {
            setTimeout(() => {
                forceUpdate();
            }, 0);
        }
        if (uiStatePrev !== props.uiState) {
            setTimeout(recalcHeights, REDISPLAY_DELAY);
        }
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { scrollIndex: null })));
        scrollIndexRef.current = null;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [adaptPrev, props.adapt, uiStatePrev, props.uiState]);
    (0, react_1.useEffect)(() => {
        if (state.scrollIndex !== null) {
            props.callbacks.scrollToTransaction(null);
            setState((prevState) => (Object.assign(Object.assign({}, prevState), { scrollIndex: null })));
            scrollIndexRef.current = null;
        }
        if (!react_device_detect_1.isMobile && !react_device_detect_1.isTablet) {
            setTimeout(recalcHeights, REDISPLAY_DELAY);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.scrollIndex, props.callbacks]);
    const showBalance = props.sortBy === 'date' && props.accountIds.size === 1;
    const scrollIndex = state.displayNodes.length > Number(state.scrollIndex) ? state.scrollIndex : null;
    if (props.acctTxns) {
        renderTxList(props.callbacks, props.accountIds, props.acctTxns, showBalance);
    }
    // identify dataset type
    const dataset = datasetId ? datasetsById.get(datasetId) : null;
    return (<>
      {props.uiState.showBulkEdit && (<BulkEditPanel_1.default txnArray={props.uiState.selectedTxns} inDialog autoFocus closeFn={hideEdit} saveFn={props.callbacks.bulkEditSave} longCats={props.longCats}/>)}

      {props.uiState.showDocumentBrowserTxn &&
            <DocumentBrowser_1.default onClose={() => props.callbacks.hideModal('documentBrowser')} documents={props.uiState.showDocumentBrowserTxn.attachments} selectedIds={props.callbacks.delDocIds}/>}

      <styles_1.RegisterContainer className={(0, classnames_1.default)('register-container', { tightmargins: props.tightMargins })} onKeyDown={(e) => props.callbacks.regFieldKey(e)}>
        <RegisterHeader_1.default innerRegRef={(elem) => { regComponentRef(headerEl, elem); }} callbacks={props.callbacks} uiState={props.uiState} showBalance={showBalance} accountIds={props.accountIds} showControls={props.showControls} headerFields={props.headerFields} doubleAmounts={props.doubleAmounts} showAccountColors={props.showAccountColors} acctTxns={props.acctTxns} noNew={props.noNew} sizeChanged={props.sizeChanged} hideSearch={props.hideSearch} hideColumnsHeader={props.hideColumnsHeader} transactionListMetrics={transactionListMetrics} reminderSetting={props.reminderSetting} sortBy={props.sortBy} sortOrder={props.sortOrder} draggableFields={Boolean(props.regFieldsOrderChange)} dataset={dataset} showDebtErrorMessage={props.showDebtErrorMessage} calendarDate={props.calendarDate}/>
        {props.acctTxns.size || props.uiState.showNewTxn ?
            <>
            {props.sizeToContent &&
                    <div>
                {state.displayNodes.map((item) => item.node)}
              </div>}

            {!props.sizeToContent &&
                    <react_tiny_virtual_list_dmk_1.default height={(state.parent ? state.parent.clientHeight : state.bodyOffset) - state.bodyOffset} itemCount={state.displayNodes.length} overscanCount={8} itemSize={getItemSize} scrollToIndex={scrollIndex !== null ? scrollIndex : undefined} scrollToAlignment={'start'} ref={(elem) => { virtualList.current = elem; }} renderItem={({ index, style }) => (<div key={index} style={Object.assign(Object.assign({}, style), { height: 'auto' })}>
                    {state.displayNodes[index] ? state.displayNodes[index].node : ''}
                  </div>)} className={classes.VL} 
                    // @ts-expect-error: FIXME - Property 'id' does not exist 
                    id="txn-register-virtual-list"/>}
          </>
            : zeroStateContainer}
        <TxnPageFooter_1.default footerRef={(elem) => { regComponentRef(footerEl, elem); }} hideFooter={props.hideFooter} hideSearch={props.hideSearch} classes={classes} transactionListMetrics={transactionListMetrics} theme={theme}/>
      </styles_1.RegisterContainer>
    </>);
};
exports.default = (0, react_1.memo)(TransactionPage);
